/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPdpBaseInfo
// ====================================================

export interface GetPdpBaseInfo_catalog_product_base_info_shop_trait {
  category: number | null;
  category_list: string[] | null;
  style: string | null;
  minor_style: string | null;
  minor_category: number | null;
  minor_category_list: string[] | null;
  age10: boolean | null;
  age20early: boolean | null;
  age20mid: boolean | null;
  age20late: boolean | null;
  age30early: boolean | null;
  age30mid: boolean | null;
  age30late: boolean | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_customer_center_business_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_customer_center_lunch_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_customer_center {
  /**
   * 고객센터 운영시간
   */
  business_time: GetPdpBaseInfo_catalog_product_base_info_shop_customer_center_business_time | null;
  /**
   * 고객센터 점심시간
   */
  lunch_time: GetPdpBaseInfo_catalog_product_base_info_shop_customer_center_lunch_time | null;
  /**
   * 고객센터 휴일
   */
  closed_week_day_list: PdpWeekDayType[] | null;
  /**
   * 공휴일 휴무 여부
   */
  is_closed_on_holiday: boolean | null;
  /**
   * 담당자명
   */
  manager_name: string | null;
  /**
   * 담당자 연락처
   */
  manager_tel: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_main_contact {
  name: string | null;
  email: string | null;
  landline_number: string | null;
  mobile_number: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_business_license {
  /**
   * 사업자등록증 번호
   */
  registration_number: string | null;
  /**
   * 업체(법인)명
   */
  company_name: string | null;
  /**
   * 대표자명
   */
  representative_name: string | null;
  /**
   * 업태
   */
  business_category: string | null;
  /**
   * 종목
   */
  business_subcategory: string | null;
  /**
   * 사업장소재지
   */
  company_address: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_shop_business_info_seller_info {
  terms_of_use_policy_url: string;
  privacy_policy_url: string;
  kakao_cs_url: string | null;
  naver_cs_url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_shop_business_info {
  seller_info: GetPdpBaseInfo_catalog_product_base_info_shop_shop_business_info_seller_info;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_online_sales_license {
  /**
   * 라이센스 번호
   */
  license_number: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_shipping_address {
  postcode: string | null;
  address1: string | null;
  address2: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_return_address {
  postcode: string | null;
  address1: string | null;
  address2: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_shop_category_list {
  /**
   * id
   */
  id: string;
  /**
   * 이름
   */
  name: string;
  /**
   * 카테고리 클릭시 노출될 딥링크 url(store_home)
   */
  store_home_deep_link: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop_usable_mileage {
  /**
   * 마일리지 사용 허용 여부. 이 값이 false 이면 마일리지 사용률 정보는 기입하지 않음(null)
   */
  use_mileage: boolean;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 기본값 (3 퍼센트 -> 300으로 표기)
   */
  default_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 셀러가 추가 설정한 값 (7 퍼센트 -> 700으로 표기)
   */
  seller_specific_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 총합(기본값 + 셀러가 추가 설정한 값) (10 퍼센트 -> 1000으로 표기)
   */
  total_use_mileage_rate_bp: number | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_shop {
  id: string;
  main_domain: string;
  name: string;
  url: string;
  keywords: string;
  typical_image_url: string | null;
  bookmark_count: number | null;
  /**
   * 쇼핑몰 즐겨찾기 여부
   */
  is_saved_shop: boolean;
  trait: GetPdpBaseInfo_catalog_product_base_info_shop_trait;
  customer_center_tel: string | null;
  customer_center: GetPdpBaseInfo_catalog_product_base_info_shop_customer_center | null;
  main_contact: GetPdpBaseInfo_catalog_product_base_info_shop_main_contact | null;
  business_license: GetPdpBaseInfo_catalog_product_base_info_shop_business_license | null;
  shop_business_info: GetPdpBaseInfo_catalog_product_base_info_shop_shop_business_info | null;
  online_sales_license: GetPdpBaseInfo_catalog_product_base_info_shop_online_sales_license | null;
  shipping_address: GetPdpBaseInfo_catalog_product_base_info_shop_shipping_address | null;
  return_address: GetPdpBaseInfo_catalog_product_base_info_shop_return_address | null;
  type: PdpShopType;
  zpay_status: PdpShopZpayStatus | null;
  shop_category_list: GetPdpBaseInfo_catalog_product_base_info_shop_shop_category_list[];
  parent_id: string | null;
  sale_type: string | null;
  /**
   * 마일리지 적립 가능한 스토어 여부
   */
  is_mileage_shop: boolean;
  coupon_description: string | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율
   */
  usable_mileage: GetPdpBaseInfo_catalog_product_base_info_shop_usable_mileage | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_trait {
  category: number | null;
  category_list: string[] | null;
  style: string | null;
  minor_style: string | null;
  minor_category: number | null;
  minor_category_list: string[] | null;
  age10: boolean | null;
  age20early: boolean | null;
  age20mid: boolean | null;
  age20late: boolean | null;
  age30early: boolean | null;
  age30mid: boolean | null;
  age30late: boolean | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_customer_center_business_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_customer_center_lunch_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_customer_center {
  /**
   * 고객센터 운영시간
   */
  business_time: GetPdpBaseInfo_catalog_product_base_info_brand_home_customer_center_business_time | null;
  /**
   * 고객센터 점심시간
   */
  lunch_time: GetPdpBaseInfo_catalog_product_base_info_brand_home_customer_center_lunch_time | null;
  /**
   * 고객센터 휴일
   */
  closed_week_day_list: PdpWeekDayType[] | null;
  /**
   * 공휴일 휴무 여부
   */
  is_closed_on_holiday: boolean | null;
  /**
   * 담당자명
   */
  manager_name: string | null;
  /**
   * 담당자 연락처
   */
  manager_tel: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_main_contact {
  name: string | null;
  email: string | null;
  landline_number: string | null;
  mobile_number: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_business_license {
  /**
   * 사업자등록증 번호
   */
  registration_number: string | null;
  /**
   * 업체(법인)명
   */
  company_name: string | null;
  /**
   * 대표자명
   */
  representative_name: string | null;
  /**
   * 업태
   */
  business_category: string | null;
  /**
   * 종목
   */
  business_subcategory: string | null;
  /**
   * 사업장소재지
   */
  company_address: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_shop_business_info_seller_info {
  terms_of_use_policy_url: string;
  privacy_policy_url: string;
  kakao_cs_url: string | null;
  naver_cs_url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_shop_business_info {
  seller_info: GetPdpBaseInfo_catalog_product_base_info_brand_home_shop_business_info_seller_info;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_online_sales_license {
  /**
   * 라이센스 번호
   */
  license_number: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_shipping_address {
  postcode: string | null;
  address1: string | null;
  address2: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_return_address {
  postcode: string | null;
  address1: string | null;
  address2: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_shop_category_list {
  /**
   * id
   */
  id: string;
  /**
   * 이름
   */
  name: string;
  /**
   * 카테고리 클릭시 노출될 딥링크 url(store_home)
   */
  store_home_deep_link: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home_usable_mileage {
  /**
   * 마일리지 사용 허용 여부. 이 값이 false 이면 마일리지 사용률 정보는 기입하지 않음(null)
   */
  use_mileage: boolean;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 기본값 (3 퍼센트 -> 300으로 표기)
   */
  default_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 셀러가 추가 설정한 값 (7 퍼센트 -> 700으로 표기)
   */
  seller_specific_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 총합(기본값 + 셀러가 추가 설정한 값) (10 퍼센트 -> 1000으로 표기)
   */
  total_use_mileage_rate_bp: number | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_brand_home {
  id: string;
  main_domain: string;
  name: string;
  url: string;
  keywords: string;
  typical_image_url: string | null;
  bookmark_count: number | null;
  /**
   * 쇼핑몰 즐겨찾기 여부
   */
  is_saved_shop: boolean;
  trait: GetPdpBaseInfo_catalog_product_base_info_brand_home_trait;
  customer_center_tel: string | null;
  customer_center: GetPdpBaseInfo_catalog_product_base_info_brand_home_customer_center | null;
  main_contact: GetPdpBaseInfo_catalog_product_base_info_brand_home_main_contact | null;
  business_license: GetPdpBaseInfo_catalog_product_base_info_brand_home_business_license | null;
  shop_business_info: GetPdpBaseInfo_catalog_product_base_info_brand_home_shop_business_info | null;
  online_sales_license: GetPdpBaseInfo_catalog_product_base_info_brand_home_online_sales_license | null;
  shipping_address: GetPdpBaseInfo_catalog_product_base_info_brand_home_shipping_address | null;
  return_address: GetPdpBaseInfo_catalog_product_base_info_brand_home_return_address | null;
  type: PdpShopType;
  zpay_status: PdpShopZpayStatus | null;
  shop_category_list: GetPdpBaseInfo_catalog_product_base_info_brand_home_shop_category_list[];
  parent_id: string | null;
  sale_type: string | null;
  /**
   * 마일리지 적립 가능한 스토어 여부
   */
  is_mileage_shop: boolean;
  coupon_description: string | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율
   */
  usable_mileage: GetPdpBaseInfo_catalog_product_base_info_brand_home_usable_mileage | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_seller_notice {
  /**
   * 공지 아이디
   */
  id: string;
  /**
   * 타이틀
   */
  title: string | null;
  /**
   * 내용
   */
  content: string | null;
  /**
   * 공지 유형
   * - VACATION
   * - DELIVERY
   * - NORMAL
   * - IMAGE
   */
  notice_type: string;
  /**
   * 이미지 URL
   */
  image_url: string | null;
  /**
   * 휴무 종료일
   */
  date_holiday_ended: CrTimestamp | null;
  /**
   * 휴무 시작일
   */
  date_holiday_started: CrTimestamp | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_status_text_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_status_text {
  text: string;
  color: GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_status_text_color | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_ubl_object {
  section: string | null;
  type: string | null;
  id: string | null;
  idx: number | null;
  url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_ubl {
  object: GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_ubl_object | null;
  server_log: CrJson | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list {
  image_url: string;
  is_selected: boolean;
  is_dimmed: boolean;
  status_text: GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_status_text | null;
  type: PdpBrowsingType;
  shop_id: string;
  catalog_product_id: string | null;
  url: string;
  ubl: GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list_ubl | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel {
  swatch_item_list: GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel_swatch_item_list[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_text_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_text_html {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_text {
  text: string;
  color: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_text_color | null;
  html: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_text_html | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image_url {
  normal: string;
  dark: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image_webp_url {
  normal: string;
  dark: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image_jpeg_url {
  normal: string;
  dark: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image {
  url: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image_url;
  webp_url: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image_webp_url | null;
  jpeg_url: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image_jpeg_url | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text {
  text: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_text;
  prefix_image: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text_prefix_image | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_category_list {
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_image_list {
  id: string | null;
  /**
   * 이미지 URL
   */
  url: string | null;
  /**
   * 원본 이미지 URL(도메인 포함)
   */
  origin_url: string;
  /**
   * pdp 썸네일 URL(도메인 포함)
   */
  pdp_thumbnail_url: string | null;
  /**
   * pdp static image url. gif 이미지 로딩속도 개선을 위함
   */
  pdp_static_image_url: string | null;
  /**
   * 이미지 타입
   */
  image_type: PdpCatalogProductImageType;
  /**
   * 원본 이미지 width
   */
  origin_width: number | null;
  /**
   * 원본 이미지 height
   */
  origin_height: number | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_estimated_shipping_date_estimate_list {
  day: number;
  probability: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_estimated_shipping_date_repr_estimate {
  day: number;
  probability: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_estimated_shipping_date {
  estimate_list: GetPdpBaseInfo_catalog_product_base_info_product_estimated_shipping_date_estimate_list[] | null;
  repr_estimate: GetPdpBaseInfo_catalog_product_base_info_product_estimated_shipping_date_repr_estimate | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_send_date_fast_shipping_notice_banner {
  /**
   * 배너 이미지 주소
   */
  image_url: string;
  /**
   * 배너 클릭시 연결 링크
   */
  landing_url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_send_date_fast_shipping {
  /**
   * 빠른 배송 여부
   */
  is_fast_type: boolean;
  /**
   * 빠른 배송 알림 배너
   */
  notice_banner: GetPdpBaseInfo_catalog_product_base_info_product_shipping_send_date_fast_shipping_notice_banner | null;
  /**
   * 빠른 배송 유형 (ex. 판매자 지정, 배송 예측)
   */
  type_text: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_send_date {
  /**
   * 발송 예정일 텍스트 (exist_shop_holidays = true 인 경우, '판매자 배송 휴무로' 텍스트를 포함하여 응답함)
   */
  send_date_text: string;
  /**
   * 발송 예정일 관련 보충 설명 텍스트
   */
  guide_text: string | null;
  /**
   * 배송 관련 툴팁 텍스트
   */
  tooltip_text: string | null;
  /**
   * 빠른 배송 정보
   */
  fast_shipping: GetPdpBaseInfo_catalog_product_base_info_product_shipping_send_date_fast_shipping | null;
  /**
   * 옵션 발송 예정일 관련 보충 설명 텍스트
   */
  item_guide_text: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_first_order_discount {
  promotion_id: string;
  price: number;
  discount_amount: number;
  min_required_amount: number;
  guidance_image_url: string | null;
  /**
   * 할인 타입
   */
  discount_type: PdpCouponDiscountType;
  /**
   * 할인률 (첫구매 할인률)
   */
  discount_rate_bp: number | null;
  /**
   * 할인 금액 (첫구매 할인 금액)
   */
  discount_amount_of_amount_coupon: number | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_store_discount_info {
  /**
   * 할인가
   */
  discount_price: number;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인률 (max_price 를 기준으로 할인율이 계산됩니다.)
   */
  discount_rate: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_product_promotion_discount_info {
  /**
   * 할인가
   */
  discount_price: number;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인률 (max_price 를 기준으로 할인율이 계산됩니다.)
   */
  discount_rate: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_final_discount_info {
  /**
   * 할인가
   */
  discount_price: number;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인률 (max_price 를 기준으로 할인율이 계산됩니다.)
   */
  discount_rate: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_button_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info_title {
  text: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info {
  /**
   * 타이틀
   */
  title: GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info_title | null;
  /**
   * 할인가
   */
  discount_price: number;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인 타입
   */
  discount_type: PdpCouponDiscountType;
  /**
   * 할인률 (정률 쿠폰의 할인률)
   */
  discount_rate_bp: number | null;
  /**
   * 전시 할인율 (쿠폰의 할인율)
   */
  display_discount_rate_bp: number;
  /**
   * 할인 금액 (정액 쿠폰의 할인 금액)
   */
  discount_amount_of_amount_coupon: number | null;
  /**
   * 최소 주문 금액
   */
  min_required_amount: number;
  /**
   * 최대 할인 금액
   */
  max_discount_amount: number | null;
  /**
   * 쿠폰 타겟 타입 (ORDER, SHOP, SHOP_WITH_ZONLY, SHOP_GROUP, SHOP_GROUP_WITH_ZONLY, ORDER_ITEM, ORDER_ITEM_GROUP, CATEGORY, DEPARTMENT, SHIPPING_FEE, POINT)
   */
  target_type: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info_list_title {
  text: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info_list {
  /**
   * 타이틀
   */
  title: GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info_list_title | null;
  /**
   * 할인가
   */
  discount_price: number;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인 타입
   */
  discount_type: PdpCouponDiscountType;
  /**
   * 할인률 (정률 쿠폰의 할인률)
   */
  discount_rate_bp: number | null;
  /**
   * 전시 할인율 (쿠폰의 할인율)
   */
  display_discount_rate_bp: number;
  /**
   * 할인 금액 (정액 쿠폰의 할인 금액)
   */
  discount_amount_of_amount_coupon: number | null;
  /**
   * 최소 주문 금액
   */
  min_required_amount: number;
  /**
   * 최대 할인 금액
   */
  max_discount_amount: number | null;
  /**
   * 쿠폰 타겟 타입 (ORDER, SHOP, SHOP_WITH_ZONLY, SHOP_GROUP, SHOP_GROUP_WITH_ZONLY, ORDER_ITEM, ORDER_ITEM_GROUP, CATEGORY, DEPARTMENT, SHIPPING_FEE, POINT)
   */
  target_type: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_bogo_promotion_discount_info {
  /**
   * 할인가
   */
  discount_price: number;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인률 (max_price 를 기준으로 할인율이 계산됩니다.)
   */
  discount_rate: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info_badge_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info_badge {
  text: string;
  color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info_badge_color | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info {
  /**
   * 가격
   */
  price: number;
  /**
   * color
   */
  color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info_color;
  /**
   * 가격 뱃지 (ex. 쿠폰할인가, 첫구매가, 직잭위크 등 CMS 정보 등)
   */
  badge: GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info_badge | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_discount_rate_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_price_with_currency {
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_badge_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_badge {
  text: string;
  color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_badge_color | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price {
  /**
   * 가격
   */
  price: number;
  /**
   * 가격 with 통화
   */
  price_with_currency: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_price_with_currency;
  /**
   * color
   */
  color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_color;
  /**
   * 가격 뱃지 (ex. 쿠폰할인가, 첫구매가, 직잭위크 등 CMS 정보 등)
   */
  badge: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_badge | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_price_with_currency {
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_badge_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_badge {
  text: string;
  color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_badge_color | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional {
  /**
   * 가격
   */
  price: number;
  /**
   * 가격 with 통화
   */
  price_with_currency: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_price_with_currency;
  /**
   * color
   */
  color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_color;
  /**
   * 가격 뱃지 (ex. 쿠폰할인가, 첫구매가, 직잭위크 등 CMS 정보 등)
   */
  badge: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional_badge | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price {
  /**
   * 할인률 (max_price 기준으로 final_price 를 나누어 할인율이 계산됩니다. 다만 final_price_highlight 값이 존재할 경우 final_price 보다 먼저 선택되어 계산됩니다.)
   */
  discount_rate: number;
  /**
   * 할인률 color
   */
  discount_rate_color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_discount_rate_color;
  /**
   * 노출 최종가
   */
  final_price: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price;
  /**
   * 노출 최종가 (3중가 표기시 활용)
   */
  final_price_additional: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price_final_price_additional | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_price {
  /**
   * 할인가 자세히 보기 버튼 노출 여부
   */
  is_visible_discount_detail_button: boolean;
  /**
   * 첫구매가 혜택
   */
  first_order_discount: GetPdpBaseInfo_catalog_product_base_info_product_product_price_first_order_discount | null;
  /**
   * 자사몰 할인 정보(=셀러측 할인)
   */
  store_discount_info: GetPdpBaseInfo_catalog_product_base_info_product_product_price_store_discount_info | null;
  /**
   * 지그재그 추가 할인 정보(구. 제트할인가)
   */
  product_promotion_discount_info: GetPdpBaseInfo_catalog_product_base_info_product_product_price_product_promotion_discount_info | null;
  /**
   * 최종 할인 정보
   */
  final_discount_info: GetPdpBaseInfo_catalog_product_base_info_product_product_price_final_discount_info;
  /**
   * 쿠폰 버튼 색상
   */
  coupon_button_color: GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_button_color;
  /**
   * 쿠폰 할인 정보
   */
  coupon_discount_info: GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info | null;
  /**
   * 쿠폰 할인 정보 리스트
   */
  coupon_discount_info_list: GetPdpBaseInfo_catalog_product_base_info_product_product_price_coupon_discount_info_list[] | null;
  /**
   * BOGO 프로모션 할인 정보
   */
  bogo_promotion_discount_info: GetPdpBaseInfo_catalog_product_base_info_product_product_price_bogo_promotion_discount_info | null;
  /**
   * 노출 원가 정보
   */
  max_price_info: GetPdpBaseInfo_catalog_product_base_info_product_product_price_max_price_info;
  /**
   * atf 노출용 최종가 정보
   */
  display_final_price: GetPdpBaseInfo_catalog_product_base_info_product_product_price_display_final_price;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_bogo_info {
  /**
   * N+1 프로모션 적용을 위해 요구되는 최소 수량 (N값)
   */
  required_quantity: number | null;
  /**
   * 프로모션 할인 타입
   */
  discount_type: PdpBogoDiscountType | null;
  /**
   * 프로모션 할인 금액
   */
  discount_amount: number | null;
  /**
   * 프로모션 할인률
   */
  discount_rate_bp: number | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_background_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_badge_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_point_color {
  normal: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_image_url {
  normal: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_icon_url {
  normal: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info {
  /**
   * 배너 배경 컬러
   */
  background_color: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_background_color;
  /**
   * 뱃지 컬러 (6,000원 더 비싸져요)
   */
  badge_color: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_badge_color | null;
  /**
   * 포인트 컬러 (헤더 색상)
   */
  point_color: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_point_color | null;
  /**
   * 이미지 URL
   */
  image_url: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_image_url | null;
  /**
   * icon url
   */
  icon_url: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info_icon_url | null;
  /**
   * 랜딩 URL
   */
  landing_url: string | null;
  /**
   * 프로모션 이름
   */
  promotion_name: string | null;
  /**
   * 가격 차이
   */
  price_diff: number | null;
  /**
   * 남은 시간
   */
  end_time: CrTimestamp | null;
  /**
   * 텍스트
   */
  text: string | null;
  /**
   * 차액
   */
  diff_amount_text: string | null;
  /**
   * 원 비싸져요
   */
  postfix_badge_text: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_discount_banner_info {
  /**
   * 배너 내용
   */
  text: string;
  /**
   * 클릭시 연결되는 url
   */
  landing_url: string | null;
  /**
   * 배너 내용 앞쪽에 위치시킬 아이콘 유형
   */
  icon_type: PdpFloatingBannerIconType | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_promotion_info {
  /**
   * N+1 프로모션 적용을 위해 요구되는 최소 수량 (N값)
   */
  bogo_required_quantity: number | null;
  /**
   * N+1 프로모션 정보
   */
  bogo_info: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_bogo_info | null;
  /**
   * 플롯 배너
   */
  float_banner_info: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_float_banner_info | null;
  /**
   * 직진 쿠폰 배너
   */
  discount_banner_info: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info_discount_banner_info | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_discount_info {
  image_url: string | null;
  title: string | null;
  color: string | null;
  end_time: CrTimestamp | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_pdp_image_rolling_banner_item_list {
  id: string;
  image_url: string;
  landing_url: string;
  aspect_ratio: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_pdp_image_rolling_banner {
  item_list: GetPdpBaseInfo_catalog_product_base_info_product_pdp_image_rolling_banner_item_list[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_preorder {
  /**
   * 프리오더 주문 시작
   */
  start_at: CrTimestamp;
  /**
   * 프리오더 주문 종료
   */
  end_at: CrTimestamp;
  /**
   * 프리오더 주문 배송 예정
   */
  shipping_at: CrTimestamp;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_item_attribute_list_value_list {
  /**
   * 코드
   */
  code: string | null;
  /**
   * 속성 값
   */
  value: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_item_attribute_list {
  /**
   * 순서
   */
  order: number;
  /**
   * 속성명
   */
  name: string;
  /**
   * 속성 값
   */
  value_list: GetPdpBaseInfo_catalog_product_base_info_product_product_item_attribute_list_value_list[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_essentials {
  name: string;
  value: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_trait_list {
  /**
   * trait type : EXCLUSIVE, SAMPLE, RAFFLE
   */
  type: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_fee_return_fee {
  /**
   * 전체 반품 배송비
   */
  total_fee: number;
  /**
   * 부분 반품 배송비
   */
  partial_fee: number | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_fee_notice_list {
  /**
   * 권역별 추가배송비 문구
   */
  area_fee_text: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_fee {
  /**
   * 배송비 타입
   */
  fee_type: PdpShippingFeeType;
  /**
   * 기본 배송비
   */
  base_fee: number;
  /**
   * 조건부 무료 배송비
   */
  minimum_free_shipping_fee: number | null;
  /**
   * 추가 배송비 문구
   */
  additional_shipping_fee_text: string | null;
  /**
   * 반품 배송비
   */
  return_fee: GetPdpBaseInfo_catalog_product_base_info_product_shipping_fee_return_fee;
  /**
   * 교환 배송비
   */
  exchange_fee: number;
  /**
   * 배송비 관련 알림 문구
   */
  notice_list: GetPdpBaseInfo_catalog_product_base_info_product_shipping_fee_notice_list | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_badge_above_atf_title_badge_list {
  image_url: string;
  type: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_badge_below_atf_price_badge_list {
  image_url: string;
  type: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_badge {
  /**
   * atf 상품명 위쪽에 위치하는 뱃지
   */
  above_atf_title_badge_list: GetPdpBaseInfo_catalog_product_base_info_product_badge_above_atf_title_badge_list[] | null;
  /**
   * atf 가격 아래쪽에 위치하는 뱃지
   */
  below_atf_price_badge_list: GetPdpBaseInfo_catalog_product_base_info_product_badge_below_atf_price_badge_list[] | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_extra_description_list {
  /**
   * 연동필드 구분자
   */
  key: string | null;
  /**
   * 연동필드(ex. html 코드 형태)
   */
  value: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_reliability_text {
  type: PdpComponentType;
  position: number;
  /**
   * 텍스트
   */
  text: string;
  /**
   * HTML 텍스트 여부
   */
  is_html_text: boolean | null;
  /**
   * 텍스트 스타일
   */
  style: PdpTextStyle | null;
  /**
   * 텍스트 정렬
   */
  align: PdpTextAlign | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_reliability {
  value: number;
  text: GetPdpBaseInfo_catalog_product_base_info_product_reliability_text;
  icon_url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_shipping_company {
  base_company: PdpShopShippingCompany | null;
  return_company: PdpShopShippingCompany | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_summary_primary_description_list {
  /**
   * 성분 설명
   */
  description: string;
  count: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_summary_warning_description_list {
  /**
   * 성분 설명
   */
  description: string;
  count: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_summary {
  /**
   * 주요 성분 설명
   */
  primary_description_list: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_summary_primary_description_list[];
  /**
   * 주의 성분 설명
   */
  warning_description_list: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_summary_warning_description_list[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_primary_ingredient_group {
  /**
   * 설명
   */
  description: string;
  /**
   * 성분 이름 list
   */
  ingredient_name_list: string[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_warning_ingredient_group {
  /**
   * 설명
   */
  description: string;
  /**
   * 성분 이름 list
   */
  ingredient_name_list: string[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_ingredient_list_primary_description_list {
  /**
   * 성분 설명
   */
  description: string;
  count: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_ingredient_list_warning_description_list {
  /**
   * 성분 설명
   */
  description: string;
  count: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_ingredient_list {
  /**
   * 주요 성분 설명 list
   */
  primary_description_list: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_ingredient_list_primary_description_list[];
  /**
   * 주의 성분 설명 list
   */
  warning_description_list: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_ingredient_list_warning_description_list[];
  /**
   * 성분
   */
  name: string;
  /**
   * 배합 목적 list
   */
  combination_purpose_list: string[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail {
  /**
   * 주요 성분 그룹
   */
  primary_ingredient_group: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_primary_ingredient_group[];
  /**
   * 주의 성분 그룹
   */
  warning_ingredient_group: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_warning_ingredient_group[];
  /**
   * 성분 리스트
   */
  ingredient_list: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail_ingredient_list[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_one_line_review_orderer_attribute_list {
  /**
   * 맞춤 정보에 노출될 html 형식의 content
   */
  content_html: string;
  /**
   * 주문 비율
   */
  order_percent: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_one_line_review_most_answered_review_question {
  /**
   * 질문
   */
  question: string;
  /**
   * 답변
   */
  answered: string;
  /**
   * 퍼센트
   */
  percent: number;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_one_line_review {
  /**
   * 주문자 특성 list
   */
  orderer_attribute_list: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_one_line_review_orderer_attribute_list[];
  /**
   * 최다 답변된 리뷰 질문
   */
  most_answered_review_question: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_one_line_review_most_answered_review_question | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_beauty_info {
  /**
   * PDP 뷰티 상품 성분 정보 요약
   */
  beauty_ingredient_summary: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_summary | null;
  /**
   * PDP 뷰티 상품 성분 상세 정보
   */
  beauty_ingredient_detail: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_ingredient_detail | null;
  /**
   * PDP 뷰티 한줄평 리뷰
   */
  beauty_one_line_review: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info_beauty_one_line_review | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_description_top_banner_ubl_object {
  section: string | null;
  type: string | null;
  id: string | null;
  idx: number | null;
  url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_description_top_banner_ubl {
  object: GetPdpBaseInfo_catalog_product_base_info_product_description_top_banner_ubl_object | null;
  server_log: CrJson | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_description_top_banner {
  image_url: string | null;
  landing_url: string | null;
  ubl: GetPdpBaseInfo_catalog_product_base_info_product_description_top_banner_ubl | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_first_order_benefit_banner {
  /**
   * 배너 노출 문구
   */
  title: string;
  /**
   * 랜딩 url 텍스트
   */
  guide_text: string | null;
  /**
   * 배너 랜딩 url
   */
  landing_url: string | null;
  /**
   * 배경 색
   */
  background_color: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_product_info_map {
  key: string;
  value: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_purchase_notice {
  title: string;
  content_list: string[] | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_store_deal_banner {
  /**
   * 배너 노출 문구 ex. 소호샵 구매하고 100원딜 혜택받기
   */
  title: string;
  /**
   * 안내 문구 ex. 소호샵 상품 10,000원(배송비 제외) 이상 구매 시 주문 가능한 이벤트 상품으로 스토어별 최초 1회만 가능
   */
  guide_text: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_vertical_page_banner_title {
  text: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_vertical_page_banner_content {
  text: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product_vertical_page_banner {
  /**
   * 배너 노출 문구
   */
  title: GetPdpBaseInfo_catalog_product_base_info_product_vertical_page_banner_title;
  /**
   * 배너 노출 문구
   */
  content: GetPdpBaseInfo_catalog_product_base_info_product_vertical_page_banner_content;
  /**
   * 배너 이미지 url
   */
  image_url: string | null;
  /**
   * 배너 랜딩 url
   */
  landing_url: string | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_product {
  id: string;
  /**
   * 상품명
   */
  name: string;
  /**
   * 찜 상품 여부
   */
  is_saved_product: boolean;
  /**
   * 구매 가능 상태
   */
  is_purchasable: boolean;
  /**
   * 상단 영역 알림 문구
   */
  top_summary_notice_text: string | null;
  /**
   * 상품 url
   */
  product_url: string;
  /**
   * 원본 상품 url with tracking param (등록형 상품인 경우 null)
   */
  source_product_url: string | null;
  /**
   * 카페24 데이터 전송용 tracking url
   */
  tracking_product_url: string | null;
  /**
   * 원본 상품 url (등록형 상품인 경우 null)
   */
  external_product_url: string | null;
  /**
   * 배송 타입
   */
  fulfillment_type: PdpCatalogFulfillmentType;
  /**
   * 입점 타입
   */
  entry_type: PdpProductEntryType;
  /**
   * 결제 타입
   */
  payment_type: PdpCatalogPaymentType;
  /**
   * 상점 ID
   */
  shop_id: number;
  /**
   * 상점의 도메인
   */
  shop_main_domain: string;
  /**
   * 솔루션사 관리코드
   */
  external_code: string | null;
  /**
   * 상품 준비 기간
   */
  preparation_period: number | null;
  /**
   * 상품 판매 상태
   */
  sales_status: PdpCatalogSalesStatus;
  /**
   * 상품 노출 상태
   */
  display_status: PdpCatalogDisplayStatus;
  /**
   * 브랜드 여부
   */
  is_brand: boolean;
  /**
   * 카테고리 key
   */
  category_key: string | null;
  /**
   * 상품 설명
   */
  description: string | null;
  /**
   * 컬러 스워치 캐러셀
   */
  color_swatch_carousel: GetPdpBaseInfo_catalog_product_base_info_product_color_swatch_carousel | null;
  /**
   * 쿠폰 이용 불가 텍스트
   */
  gaugebar_coupon_not_applicable_text: GetPdpBaseInfo_catalog_product_base_info_product_gaugebar_coupon_not_applicable_text | null;
  /**
   * 카테고리 리스트
   */
  category_list: GetPdpBaseInfo_catalog_product_base_info_product_category_list[] | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: GetPdpBaseInfo_catalog_product_base_info_product_managed_category_list[] | null;
  /**
   * 상품의 이미지 리스트
   */
  product_image_list: GetPdpBaseInfo_catalog_product_base_info_product_product_image_list[];
  /**
   * 예측 배송기간 정보(from order service)
   */
  estimated_shipping_date: GetPdpBaseInfo_catalog_product_base_info_product_estimated_shipping_date | null;
  /**
   * 예측 배송기간 정보(from order-shipment service)
   */
  shipping_send_date: GetPdpBaseInfo_catalog_product_base_info_product_shipping_send_date | null;
  /**
   * 상품의 가격 정보
   */
  product_price: GetPdpBaseInfo_catalog_product_base_info_product_product_price;
  /**
   * 프로모션 메세지. 배송기간 정보가 없을 때 해당 메세지를 보여준다
   */
  promotion_message: string;
  /**
   * 상품 프로모션 정보
   */
  promotion_info: GetPdpBaseInfo_catalog_product_base_info_product_promotion_info | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetPdpBaseInfo_catalog_product_base_info_product_discount_info | null;
  /**
   * 쿠폰 상태
   */
  coupon_available_status: PdpCouponAvailableStatus;
  /**
   * 병행 수입 배너 이미지 URL
   */
  parallel_imported_banner_image_url: string | null;
  /**
   * 최소구매수량
   */
  minimum_order_quantity: number;
  /**
   * 최대구매수량
   */
  maximum_order_quantity: number | null;
  /**
   * 최소구매수량타입 (PRODUCT, ITEM)
   */
  minimum_order_quantity_type: string | null;
  /**
   * PDP 이미지 배너
   */
  pdp_image_rolling_banner: GetPdpBaseInfo_catalog_product_base_info_product_pdp_image_rolling_banner | null;
  /**
   * 유저가 선택한 언어와 상품의 언어가 같은지
   */
  is_language_match: boolean | null;
  /**
   * 프리오더 정보
   */
  preorder: GetPdpBaseInfo_catalog_product_base_info_product_preorder | null;
  /**
   * 상품의 크리마핏 정보
   */
  crema_fit_url_list: string[];
  /**
   * 상품 품목 부가 속성 리스트
   */
  product_item_attribute_list: GetPdpBaseInfo_catalog_product_base_info_product_product_item_attribute_list[];
  /**
   * 상품정보제공 고시
   */
  essentials: GetPdpBaseInfo_catalog_product_base_info_product_essentials[];
  /**
   * 상품의 특성관련 정보
   */
  trait_list: GetPdpBaseInfo_catalog_product_base_info_product_trait_list[] | null;
  /**
   * 샘플 상품 여부
   */
  is_sample: boolean;
  /**
   * 배송비
   */
  shipping_fee: GetPdpBaseInfo_catalog_product_base_info_product_shipping_fee | null;
  /**
   * 뱃지 리스트
   */
  badge: GetPdpBaseInfo_catalog_product_base_info_product_badge;
  /**
   * 연동 상품의 기타 정보
   */
  extra_description_list: GetPdpBaseInfo_catalog_product_base_info_product_extra_description_list[] | null;
  /**
   * 신뢰도 정보
   */
  reliability: GetPdpBaseInfo_catalog_product_base_info_product_reliability | null;
  /**
   * 배송사
   */
  shipping_company: GetPdpBaseInfo_catalog_product_base_info_product_shipping_company | null;
  /**
   * 뷰티 정보
   */
  beauty_info: GetPdpBaseInfo_catalog_product_base_info_product_beauty_info | null;
  /**
   * 다른 셀러간의 동일한 상품 개수
   */
  cross_seller_product_count: number | null;
  /**
   * 브라우저 타입
   */
  browsing_type: PdpBrowsingType;
  /**
   * 상단에 노출되는 배너
   */
  description_top_banner: GetPdpBaseInfo_catalog_product_base_info_product_description_top_banner | null;
  /**
   * 첫구매 유저 혜택 배너
   */
  first_order_benefit_banner: GetPdpBaseInfo_catalog_product_base_info_product_first_order_benefit_banner | null;
  /**
   * 해외 직매입 배너 이미지 URL
   */
  oversea_direct_banner_image_url: string | null;
  /**
   * 공인 기관을 통해 소재와 혼용률을 검증받은 상품임을 인증하는 배너 이미지 URL
   */
  coa_provided_banner_image_url: string | null;
  /**
   * 추가 상품 정보
   */
  product_info_map: GetPdpBaseInfo_catalog_product_base_info_product_product_info_map[] | null;
  /**
   * 구매 주의 사항
   */
  purchase_notice: GetPdpBaseInfo_catalog_product_base_info_product_purchase_notice | null;
  /**
   * 스토어딜 배너
   */
  store_deal_banner: GetPdpBaseInfo_catalog_product_base_info_product_store_deal_banner | null;
  /**
   * 스토어딜(100원딜) 안내 배너
   */
  store_deal_guide_banner_url: string | null;
  /**
   * 전용관 배너
   */
  vertical_page_banner: GetPdpBaseInfo_catalog_product_base_info_product_vertical_page_banner | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_policy_list_content_list {
  title: string;
  description: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_policy_list {
  main_title: string;
  content_list: GetPdpBaseInfo_catalog_product_base_info_policy_list_content_list[];
}

export interface GetPdpBaseInfo_catalog_product_base_info_flags {
  show_review_summary_best_carousel: boolean;
  /**
   * PDP 매칭 옵션 상품 적용 여부
   */
  is_matching_option: boolean | null;
  /**
   * 셀렉티드 상품인지 아닌지
   */
  is_selected_shop: boolean | null;
  /**
   * 2024년 4월자 상품 카드 개편 여부(신규 상품 카드 대응 완료 후 제거되어야함)
   */
  is_plp_v2: boolean | null;
  /**
   * 단수상품(한번에 하나만 구매할 수 있는 상품)
   */
  is_purchase_only_one_at_time: boolean | null;
  /**
   * 해외 직매입 사이즈 탭 노출
   */
  is_size_tab_visible: boolean | null;
  /**
   * 장바구니 버튼 노출 여부
   */
  is_cart_button_visible: boolean | null;
  /**
   * 크롤링으로 판단되었는지 여부(ex. 쿠폰 할인가가 아닌 지그재그 추가 할인가로만 노출하는 형태 등으로 활용될 수 있음)
   */
  is_detected_crawler: boolean | null;
}

export interface GetPdpBaseInfo_catalog_product_base_info_key_color_buy_button_text {
  /**
   * 비활성화 케이스에 대한 키 컬러
   */
  disabled: string;
  /**
   * 활성화 케이스에 대한 키 컬러
   */
  enabled: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_key_color_buy_button_background {
  /**
   * 비활성화 케이스에 대한 키 컬러
   */
  disabled: string;
  /**
   * 활성화 케이스에 대한 키 컬러
   */
  enabled: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info_key_color_buy_button {
  /**
   * 텍스트 키 컬러
   */
  text: GetPdpBaseInfo_catalog_product_base_info_key_color_buy_button_text;
  /**
   * 배경 키 컬러
   */
  background: GetPdpBaseInfo_catalog_product_base_info_key_color_buy_button_background;
}

export interface GetPdpBaseInfo_catalog_product_base_info_key_color {
  /**
   * 구매하기 버튼
   */
  buy_button: GetPdpBaseInfo_catalog_product_base_info_key_color_buy_button;
  /**
   * 상단 네비게이션 바에 위치하고 있는 장바구니 버튼 색상
   */
  cart_button_of_navigation_bar: string;
  /**
   * atf 영역 할인 정보에 적용되는 색상
   */
  discount_info_of_atf: string;
}

export interface GetPdpBaseInfo_catalog_product_base_info {
  /**
   * 쇼핑몰 정보
   */
  shop: GetPdpBaseInfo_catalog_product_base_info_shop;
  /**
   * 브랜드 홈 정보
   */
  brand_home: GetPdpBaseInfo_catalog_product_base_info_brand_home | null;
  /**
   * 공지 정보
   */
  seller_notice: GetPdpBaseInfo_catalog_product_base_info_seller_notice | null;
  /**
   * 입점형 내재화 상품정보
   */
  product: GetPdpBaseInfo_catalog_product_base_info_product;
  /**
   * 추천탭 라벨
   */
  recommendation_tab_label: string;
  /**
   * 정책 및 약관
   */
  policy_list: GetPdpBaseInfo_catalog_product_base_info_policy_list[];
  /**
   * PDP 노출 여부 판단 BOOLEAN 값 들
   */
  flags: GetPdpBaseInfo_catalog_product_base_info_flags;
  /**
   * PDP 전체적인 컨셉에 활용되는 Key Color
   */
  key_color: GetPdpBaseInfo_catalog_product_base_info_key_color;
}

export interface GetPdpBaseInfo_pdp_btf_page_tab_list_tab_title {
  text: string;
}

export interface GetPdpBaseInfo_pdp_btf_page_tab_list_tab_sub_title {
  text: string;
}

export interface GetPdpBaseInfo_pdp_btf_page_tab_list_tab_dot_info_text {
  text: string;
}

export interface GetPdpBaseInfo_pdp_btf_page_tab_list_tab_dot_info {
  id: string;
  text: GetPdpBaseInfo_pdp_btf_page_tab_list_tab_dot_info_text | null;
}

export interface GetPdpBaseInfo_pdp_btf_page_tab_list_tab {
  /**
   * 탭의 unique 식별자(tab 단위 reload 또는 tab 단위 페이지네이션 시 사용)
   */
  id: string;
  /**
   * 탭 타입(DETAIL=상품정보, REVIEW=리뷰, PRODUCT_RECOMMEND=추천, SIZE=사이즈, 성분=INGREDIENT, CONTACT=문의)
   */
  type: string;
  /**
   * 탭 제목
   */
  title: GetPdpBaseInfo_pdp_btf_page_tab_list_tab_title;
  /**
   * 탭 제목 근처에 노출되는 보조 문구
   */
  sub_title: GetPdpBaseInfo_pdp_btf_page_tab_list_tab_sub_title | null;
  /**
   * 선택된 탭인지 여부
   */
  is_selected: boolean;
  /**
   * 레드닷 노출
   */
  dot_info: GetPdpBaseInfo_pdp_btf_page_tab_list_tab_dot_info | null;
}

export interface GetPdpBaseInfo_pdp_btf_page_tab_list {
  tab: GetPdpBaseInfo_pdp_btf_page_tab_list_tab;
}

export interface GetPdpBaseInfo_pdp_btf_page {
  /**
   * 서브 탭 목록
   */
  tab_list: GetPdpBaseInfo_pdp_btf_page_tab_list[];
}

export interface GetPdpBaseInfo {
  /**
   * PDP 기본 정보 (source = 네이버 등 제휴사를 통해 유입된 캠페인 코드)
   */
  catalog_product_base_info: GetPdpBaseInfo_catalog_product_base_info | null;
  /**
   * PDP 네이티브 페이지 정보(BTF)
   */
  pdp_btf_page: GetPdpBaseInfo_pdp_btf_page;
}

export interface GetPdpBaseInfoVariables {
  catalog_product_id: string;
  source?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UsableMileage
// ====================================================

export interface UsableMileage {
  /**
   * 마일리지 사용 허용 여부. 이 값이 false 이면 마일리지 사용률 정보는 기입하지 않음(null)
   */
  use_mileage: boolean;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 기본값 (3 퍼센트 -> 300으로 표기)
   */
  default_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 셀러가 추가 설정한 값 (7 퍼센트 -> 700으로 표기)
   */
  seller_specific_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 총합(기본값 + 셀러가 추가 설정한 값) (10 퍼센트 -> 1000으로 표기)
   */
  total_use_mileage_rate_bp: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PdpTextPart
// ====================================================

export interface PdpTextPart {
  type: PdpComponentType;
  position: number;
  /**
   * 텍스트
   */
  text: string;
  /**
   * HTML 텍스트 여부
   */
  is_html_text: boolean | null;
  /**
   * 텍스트 스타일
   */
  style: PdpTextStyle | null;
  /**
   * 텍스트 정렬
   */
  align: PdpTextAlign | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PDPShop
// ====================================================

export interface PDPShop_trait {
  category: number | null;
  category_list: string[] | null;
  style: string | null;
  minor_style: string | null;
  minor_category: number | null;
  minor_category_list: string[] | null;
  age10: boolean | null;
  age20early: boolean | null;
  age20mid: boolean | null;
  age20late: boolean | null;
  age30early: boolean | null;
  age30mid: boolean | null;
  age30late: boolean | null;
}

export interface PDPShop_customer_center_business_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface PDPShop_customer_center_lunch_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface PDPShop_customer_center {
  /**
   * 고객센터 운영시간
   */
  business_time: PDPShop_customer_center_business_time | null;
  /**
   * 고객센터 점심시간
   */
  lunch_time: PDPShop_customer_center_lunch_time | null;
  /**
   * 고객센터 휴일
   */
  closed_week_day_list: PdpWeekDayType[] | null;
  /**
   * 공휴일 휴무 여부
   */
  is_closed_on_holiday: boolean | null;
  /**
   * 담당자명
   */
  manager_name: string | null;
  /**
   * 담당자 연락처
   */
  manager_tel: string | null;
}

export interface PDPShop_main_contact {
  name: string | null;
  email: string | null;
  landline_number: string | null;
  mobile_number: string | null;
}

export interface PDPShop_business_license {
  /**
   * 사업자등록증 번호
   */
  registration_number: string | null;
  /**
   * 업체(법인)명
   */
  company_name: string | null;
  /**
   * 대표자명
   */
  representative_name: string | null;
  /**
   * 업태
   */
  business_category: string | null;
  /**
   * 종목
   */
  business_subcategory: string | null;
  /**
   * 사업장소재지
   */
  company_address: string | null;
}

export interface PDPShop_shop_business_info_seller_info {
  terms_of_use_policy_url: string;
  privacy_policy_url: string;
  kakao_cs_url: string | null;
  naver_cs_url: string | null;
}

export interface PDPShop_shop_business_info {
  seller_info: PDPShop_shop_business_info_seller_info;
}

export interface PDPShop_online_sales_license {
  /**
   * 라이센스 번호
   */
  license_number: string | null;
}

export interface PDPShop_shipping_address {
  postcode: string | null;
  address1: string | null;
  address2: string | null;
}

export interface PDPShop_return_address {
  postcode: string | null;
  address1: string | null;
  address2: string | null;
}

export interface PDPShop_shop_category_list {
  /**
   * id
   */
  id: string;
  /**
   * 이름
   */
  name: string;
  /**
   * 카테고리 클릭시 노출될 딥링크 url(store_home)
   */
  store_home_deep_link: string | null;
}

export interface PDPShop_usable_mileage {
  /**
   * 마일리지 사용 허용 여부. 이 값이 false 이면 마일리지 사용률 정보는 기입하지 않음(null)
   */
  use_mileage: boolean;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 기본값 (3 퍼센트 -> 300으로 표기)
   */
  default_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 중 셀러가 추가 설정한 값 (7 퍼센트 -> 700으로 표기)
   */
  seller_specific_use_mileage_rate_bp: number | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율 총합(기본값 + 셀러가 추가 설정한 값) (10 퍼센트 -> 1000으로 표기)
   */
  total_use_mileage_rate_bp: number | null;
}

export interface PDPShop {
  id: string;
  main_domain: string;
  name: string;
  url: string;
  keywords: string;
  typical_image_url: string | null;
  bookmark_count: number | null;
  /**
   * 쇼핑몰 즐겨찾기 여부
   */
  is_saved_shop: boolean;
  trait: PDPShop_trait;
  customer_center_tel: string | null;
  customer_center: PDPShop_customer_center | null;
  main_contact: PDPShop_main_contact | null;
  business_license: PDPShop_business_license | null;
  shop_business_info: PDPShop_shop_business_info | null;
  online_sales_license: PDPShop_online_sales_license | null;
  shipping_address: PDPShop_shipping_address | null;
  return_address: PDPShop_return_address | null;
  type: PdpShopType;
  zpay_status: PdpShopZpayStatus | null;
  shop_category_list: PDPShop_shop_category_list[];
  parent_id: string | null;
  sale_type: string | null;
  /**
   * 마일리지 적립 가능한 스토어 여부
   */
  is_mileage_shop: boolean;
  coupon_description: string | null;
  /**
   * 스토어 기준 상품 구매에 마일리지 사용 가능한 비율
   */
  usable_mileage: PDPShop_usable_mileage | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PdpBogoDiscountType {
  AMOUNT = "AMOUNT",
  RATE = "RATE",
}

export enum PdpBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum PdpCatalogDisplayStatus {
  HIDDEN = "HIDDEN",
  VISIBLE = "VISIBLE",
}

export enum PdpCatalogFulfillmentType {
  DIGITAL_DELIVERY = "DIGITAL_DELIVERY",
  MERCHANT = "MERCHANT",
  ON_SITE = "ON_SITE",
  VENDOR_FLEX = "VENDOR_FLEX",
  ZIGZIN = "ZIGZIN",
}

export enum PdpCatalogPaymentType {
  EXTERNAL = "EXTERNAL",
  ZPAY = "ZPAY",
}

export enum PdpCatalogProductImageType {
  CONTENT = "CONTENT",
  MAIN = "MAIN",
  SUB = "SUB",
}

export enum PdpCatalogSalesStatus {
  CLOSED = "CLOSED",
  ON_SALE = "ON_SALE",
  PREPARING = "PREPARING",
  SOLD_OUT = "SOLD_OUT",
  SUSPENDED = "SUSPENDED",
}

export enum PdpComponentType {
  PDP_BEAUTY_PRODUCT_SUMMARY = "PDP_BEAUTY_PRODUCT_SUMMARY",
  PDP_BENEFIT_CONTENT = "PDP_BENEFIT_CONTENT",
  PDP_CENTER_ALIGNED_TEXT_BANNER = "PDP_CENTER_ALIGNED_TEXT_BANNER",
  PDP_COLOR_CHIP = "PDP_COLOR_CHIP",
  PDP_COLOR_SWATCH_CAROUSEL = "PDP_COLOR_SWATCH_CAROUSEL",
  PDP_COMMON_TEXT_WITH_IMAGE = "PDP_COMMON_TEXT_WITH_IMAGE",
  PDP_DESCRIPTION_CONTENT = "PDP_DESCRIPTION_CONTENT",
  PDP_EPICK_GROUP = "PDP_EPICK_GROUP",
  PDP_ESTIMATED_LOWEST_PRICE_INFO = "PDP_ESTIMATED_LOWEST_PRICE_INFO",
  PDP_EXPANDABLE_EXPLANATION = "PDP_EXPANDABLE_EXPLANATION",
  PDP_FITTING_MODEL = "PDP_FITTING_MODEL",
  PDP_FULL_WIDTH_NOTICE_BANNER = "PDP_FULL_WIDTH_NOTICE_BANNER",
  PDP_HORIZONTAL_CARD_GROUP = "PDP_HORIZONTAL_CARD_GROUP",
  PDP_IMAGE_BANNER_GROUP = "PDP_IMAGE_BANNER_GROUP",
  PDP_LINE_WITH_MARGIN = "PDP_LINE_WITH_MARGIN",
  PDP_LIVE_BANNER = "PDP_LIVE_BANNER",
  PDP_MAX_REWARD_BENEFIT_INFO = "PDP_MAX_REWARD_BENEFIT_INFO",
  PDP_NORMAL_SHIPPING_GROUP = "PDP_NORMAL_SHIPPING_GROUP",
  PDP_PRICE_BENEFIT_SUMMARY = "PDP_PRICE_BENEFIT_SUMMARY",
  PDP_PRICE_GROUP = "PDP_PRICE_GROUP",
  PDP_PROMOTION_PARTICIPATE_CONDITION_INFO = "PDP_PROMOTION_PARTICIPATE_CONDITION_INFO",
  PDP_PROMOTION_PERIOD = "PDP_PROMOTION_PERIOD",
  PDP_PROMOTION_WINNER_ANNOUNCEMENT_INFO = "PDP_PROMOTION_WINNER_ANNOUNCEMENT_INFO",
  PDP_RECOMMEND_PRODUCT_HEADER = "PDP_RECOMMEND_PRODUCT_HEADER",
  PDP_REVIEW_GROUP = "PDP_REVIEW_GROUP",
  PDP_ROLLING_BANNER = "PDP_ROLLING_BANNER",
  PDP_SHOP_SUMMARY = "PDP_SHOP_SUMMARY",
  PDP_SIMPLE_NOTICE = "PDP_SIMPLE_NOTICE",
  PDP_SIMPLE_TEXT_BANNER = "PDP_SIMPLE_TEXT_BANNER",
  PDP_SINGLE_HORIZONTAL_CARD_GROUP = "PDP_SINGLE_HORIZONTAL_CARD_GROUP",
  PDP_SKELETON = "PDP_SKELETON",
  PDP_STYLE_REVIEW_GROUP = "PDP_STYLE_REVIEW_GROUP",
  PDP_TEXT_LINK = "PDP_TEXT_LINK",
  PDP_TITLE_WITH_PRODUCT_SUMMARY = "PDP_TITLE_WITH_PRODUCT_SUMMARY",
  PDP_VERTICAL_GROUP = "PDP_VERTICAL_GROUP",
  PDP_WEB_CONTENT = "PDP_WEB_CONTENT",
  PDP_WEB_DESCRIPTION = "PDP_WEB_DESCRIPTION",
  PDP_ZIGZAG_GIFT_PRODUCT_INFO = "PDP_ZIGZAG_GIFT_PRODUCT_INFO",
  PDP_ZIGZIN_SHIPPING_BANNER = "PDP_ZIGZIN_SHIPPING_BANNER",
  PDP_ZIGZIN_SHIPPING_GROUP = "PDP_ZIGZIN_SHIPPING_GROUP",
  UX_AD_BANNER_CARD = "UX_AD_BANNER_CARD",
  UX_AD_DISPLAY_BANNER_GROUP = "UX_AD_DISPLAY_BANNER_GROUP",
  UX_AD_DISPLAY_LARGE_BANNER = "UX_AD_DISPLAY_LARGE_BANNER",
  UX_AD_DISPLAY_MID_BANNER = "UX_AD_DISPLAY_MID_BANNER",
  UX_AD_DISPLAY_SMALL_BANNER = "UX_AD_DISPLAY_SMALL_BANNER",
  UX_AD_DISPLAY_X_LARGE_BANNER = "UX_AD_DISPLAY_X_LARGE_BANNER",
  UX_AD_DISPLAY_X_MID_BANNER = "UX_AD_DISPLAY_X_MID_BANNER",
  UX_BANNER_ITEM = "UX_BANNER_ITEM",
  UX_BANNER_LIST = "UX_BANNER_LIST",
  UX_BRAND_THEME_CONTENT = "UX_BRAND_THEME_CONTENT",
  UX_BUTTON = "UX_BUTTON",
  UX_CATEGORY = "UX_CATEGORY",
  UX_CHECK_BUTTON_AND_SORTING = "UX_CHECK_BUTTON_AND_SORTING",
  UX_CLP_CATEGORY = "UX_CLP_CATEGORY",
  UX_ENTRY_BANNER = "UX_ENTRY_BANNER",
  UX_FULL_WIDTH_IMAGE_BANNER_GROUP = "UX_FULL_WIDTH_IMAGE_BANNER_GROUP",
  UX_GOODS_CARD_ITEM = "UX_GOODS_CARD_ITEM",
  UX_GOODS_CARD_LIST = "UX_GOODS_CARD_LIST",
  UX_GOODS_CAROUSEL = "UX_GOODS_CAROUSEL",
  UX_GOODS_FILTER_LIST = "UX_GOODS_FILTER_LIST",
  UX_GOODS_GROUP = "UX_GOODS_GROUP",
  UX_IMAGE = "UX_IMAGE",
  UX_IMAGE_AND_TEXT_TITLE = "UX_IMAGE_AND_TEXT_TITLE",
  UX_IMAGE_BANNER_GROUP = "UX_IMAGE_BANNER_GROUP",
  UX_IMAGE_GOODS_CARD_ITEM = "UX_IMAGE_GOODS_CARD_ITEM",
  UX_LINE = "UX_LINE",
  UX_LINE_WITH_MARGIN = "UX_LINE_WITH_MARGIN",
  UX_MULTILINE_RANKING_CAROUSEL = "UX_MULTILINE_RANKING_CAROUSEL",
  UX_NO_RESULTS = "UX_NO_RESULTS",
  UX_PDP_RECOMMEND_CARD_GROUP = "UX_PDP_RECOMMEND_CARD_GROUP",
  UX_PDP_RECOMMEND_GROUP = "UX_PDP_RECOMMEND_GROUP",
  UX_QUICK_MENU = "UX_QUICK_MENU",
  UX_SEARCHED_SHOP_CAROUSEL = "UX_SEARCHED_SHOP_CAROUSEL",
  UX_SEGMENT_TAB = "UX_SEGMENT_TAB",
  UX_SELECTION_AND_SORTING = "UX_SELECTION_AND_SORTING",
  UX_SHOP_EXPANDABLE_LIST = "UX_SHOP_EXPANDABLE_LIST",
  UX_SHOP_GROUP = "UX_SHOP_GROUP",
  UX_SHOP_RANKING_CARD_ITEM = "UX_SHOP_RANKING_CARD_ITEM",
  UX_SMALL_TEXT_TITLE = "UX_SMALL_TEXT_TITLE",
  UX_SORTING = "UX_SORTING",
  UX_TEXT = "UX_TEXT",
  UX_TEXT_AND_MORE_BUTTON = "UX_TEXT_AND_MORE_BUTTON",
  UX_TEXT_AND_SORTING = "UX_TEXT_AND_SORTING",
  UX_TEXT_TITLE = "UX_TEXT_TITLE",
  UX_WEB_PAGE = "UX_WEB_PAGE",
  UX_ZONLY_ENTRY_BANNER = "UX_ZONLY_ENTRY_BANNER",
  UX_ZONLY_ENTRY_CARD = "UX_ZONLY_ENTRY_CARD",
  UX_ZONLY_ENTRY_GROUP = "UX_ZONLY_ENTRY_GROUP",
  UX_ZONLY_ENTRY_INFO = "UX_ZONLY_ENTRY_INFO",
}

export enum PdpCouponAvailableStatus {
  COUPON_AVAILABLE = "COUPON_AVAILABLE",
  COUPON_ISSUED = "COUPON_ISSUED",
  COUPON_NOT_APPLICABLE = "COUPON_NOT_APPLICABLE",
  COUPON_UNAVAILABLE = "COUPON_UNAVAILABLE",
  UNKNOWN = "UNKNOWN",
}

export enum PdpCouponDiscountType {
  AMOUNT = "AMOUNT",
  RATE = "RATE",
}

export enum PdpFloatingBannerIconType {
  ZIGZIN = "ZIGZIN",
}

export enum PdpProductEntryType {
  CRAWLING_API = "CRAWLING_API",
  DIRECT = "DIRECT",
  SCRAPPING = "SCRAPPING",
}

export enum PdpShippingFeeType {
  CHARGED = "CHARGED",
  CONDITIONAL_FREE = "CONDITIONAL_FREE",
  FREE = "FREE",
}

export enum PdpShopShippingCompany {
  CJ = "CJ",
  ETC = "ETC",
  HANJIN = "HANJIN",
  ILYANG = "ILYANG",
  LOGEN = "LOGEN",
  LOGIS = "LOGIS",
  LOTTE = "LOTTE",
  POSTAL = "POSTAL",
}

export enum PdpShopType {
  META = "META",
  STORE = "STORE",
  ZPAY = "ZPAY",
}

/**
 * zpay 상태
 */
export enum PdpShopZpayStatus {
  NORMAL = "NORMAL",
  PREPARING = "PREPARING",
  STOPPED = "STOPPED",
  SUSPENDED = "SUSPENDED",
}

/**
 * PdpText 정렬
 */
export enum PdpTextAlign {
  CENTER = "CENTER",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

/**
 * PdpText 스타일
 */
export enum PdpTextStyle {
  BODY_1 = "BODY_1",
  BODY_2 = "BODY_2",
  BODY_3 = "BODY_3",
  CAPTION = "CAPTION",
  CAPTION_NUM = "CAPTION_NUM",
  SUB_TITLE_1 = "SUB_TITLE_1",
  SUB_TITLE_1_2 = "SUB_TITLE_1_2",
  SUB_TITLE_2 = "SUB_TITLE_2",
  SUB_TITLE_3 = "SUB_TITLE_3",
  TITLE_1 = "TITLE_1",
  TITLE_2 = "TITLE_2",
}

/**
 * 휴일 요일
 */
export enum PdpWeekDayType {
  FRI = "FRI",
  MON = "MON",
  SAT = "SAT",
  SUN = "SUN",
  THU = "THU",
  TUE = "TUE",
  WED = "WED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
